/* eslint-disable @typescript-eslint/no-explicit-any */

import { FormikProps } from 'formik';
import { Col, Form, Row } from 'antd';
import { MInput } from '@Components/Base';

interface InputProps<T> {
  formik: FormikProps<T>;
  formikKey: keyof T;
  placeholder?: string;
  validateField?: (fieldName: string, value: string) => string | null;
}

const Input = <T,>({
  formik,
  formikKey,
  placeholder,
  validateField,
}: InputProps<T>): JSX.Element => {
  const value = formik.getFieldMeta(formikKey as any).value as string;
  const error = validateField ? validateField(String(formikKey), value) : null;
  const hasError = Boolean(error);

  return (
    <Row>
      <Col span={24}>
        <Form.Item validateStatus={hasError ? 'error' : ''} help={error}>
          <MInput
            value={value}
            onChange={(e) => {
              formik.setFieldValue(formikKey as any, e.target.value);
            }}
            onBlur={() => {
              formik.setFieldTouched(formikKey as any, true);
            }}
            placeholder={placeholder}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default Input;
